<div class="group">
  <p *ngIf="step">Claim code</p>
  <!--
    ng-blur="step.claimCodeValidation(step.output.hwLockCode)" replaced with directive claimCode
  -->
  <!-- (keyup)="step.onClaimCodeInputKeyUp($event, step.output.hwLockCode)" -->
  <input
    autocomplete="off"
    placeholder="Enter the CLAIM number, e.g. *000 0000 0000 0000"
    name="hwLockCode"
    [(ngModel)]="hwLockCode"
    [claimCode]="step.config.def"
    claimCodeFormat
    (ngModelChange)="onClaimCodeChange()"
    minlength="19"
    maxlength="19"
    #claimInput="ngModel"
    size="19"
    required
  />

  <div class="error" *ngIf="claimInput.status === 'PENDING'">
    <mat-error>Contacting validation service to validate the code...</mat-error>
  </div>

  <div
    class="error"
    *ngIf="claimInput.invalid && (claimInput.dirty || claimInput.touched)"
  >
    <mat-error *ngIf="claimInput.errors.minlength"
      >The CLAIM number should be exactly 16 symbols. First symbol is always
      asterix '*'.</mat-error
    >
    <mat-error *ngIf="claimInput.errors.maxlength"
      >Too many symbols for CLAIM number.</mat-error
    >
    <mat-error *ngIf="claimInput.errors.required"
      >The CLAIM number can be found on the bottom of your VIAVI Hardware
      Agent.</mat-error
    >
    <mat-error *ngIf="claimInput.errors.claimerror"
      >Oops!!! Something went wrong.</mat-error
    >
    <mat-error *ngIf="claimInput.errors.claimnotfoundresult"
      >The CLAIM number is not found.</mat-error
    >
  </div>
</div>
